module.exports = __webpack_public_path__ + "static/media/logo.95828c1c.png";